import {all, call, race, take, select, takeEvery, put} from 'redux-saga/effects'
import {
    eidMiddlewareAuthenticate,
    eidMiddlewareLoop,
    eidMiddlewareReadAuthenticationCertificate,
    eidMiddlewareReadCitizenCertificate,
    eidMiddlewareReadIdentitySignature,
    eidMiddlewareReadRawIdentity,
    eidMiddlewareReadRnCertificate
} from "./eid-redux-actions";

export default function* rootSaga() {
    yield all([
        call(eidMiddlewareLoop),
        takeEvery('EID_CORRECT_CARD_INSERTED', eidCardInserted)
    ])
}

function* eidCardInserted(action) {
    yield race({
        task: call(readEidData, action.eidCard),
        cancel: take('EID_CORRECT_CARD_REMOVED')
    });
}

function* readEidData(eidCard) {
    try {
        const [{certificate: authenticationCertificate}, {certificate: citizenCaCertificate}, {certificate: rnCertificate},
            {data: rawRnData}, {signature: rnDataSignature}] = yield all([
            yield eidMiddlewareReadAuthenticationCertificate(eidCard),
            yield eidMiddlewareReadCitizenCertificate(eidCard),
            yield eidMiddlewareReadRnCertificate(eidCard),
            yield eidMiddlewareReadRawIdentity(eidCard),
            yield eidMiddlewareReadIdentitySignature(eidCard),
        ]);

        window.document.getElementById("authentication-certificate").value = authenticationCertificate;
        window.document.getElementById("citizen-ca-certificate").value = citizenCaCertificate;
        window.document.getElementById("rn-certificate").value = rnCertificate;
        window.document.getElementById("raw-rn-data").value = rawRnData;
        window.document.getElementById("rn-data-signature").value = rnDataSignature;

        yield put({ type: 'EID_DATA_FULLY_READ' });

        yield executeLogin(eidCard);

    } catch (e) {
        console.log('readEidData error', e);
        yield put({ type: 'EID_DATA_READ_ERROR' });
    }
}

function* executeLogin(eidCard) {
    yield take('PERFORM_LOGIN');

    while (true) {
        let state = yield select();
        try {
            let challenge = window.document.getElementById("eid-challenge-token").value;
            let response = yield eidMiddlewareAuthenticate(eidCard, { hash: challenge, hashType: 'SHA2-512', pinCode: state.eid.pin });
            window.document.getElementById("eid-challenge-token-signature").value = response.signature;
            let form = window.document.getElementById("kc-form-eid");
            if (form) form.submit(); // page will perform a post to keycloak, this is where the flow ends on the real page
        } catch (e) {
            const statusCodes = {
                VERIFY_PIN_INCORRECT_FOUR_TRIES_REMAINING: 4,
                VERIFY_PIN_INCORRECT_THREE_TRIES_REMAINING: 3,
                VERIFY_PIN_INCORRECT_TWO_TRIES_REMAINING: 2,
                VERIFY_PIN_INCORRECT_ONE_TRY_REMAINING: 1,
                VERIFY_PIN_BLOCKED: 0,
                VERIFY_PIN_INCORRECT: 0
            };
            if (!!e.data && !!e.data.status && statusCodes.hasOwnProperty(e.data.status.code)) {
                yield put({
                    type: 'WRONG_PIN',
                    triesLeft: statusCodes[e.data.status.code]
                });
            } else {
                yield put({
                    type: 'AUTH_SIGN_ERROR',
                    error: !!e.data && !!e.data.status ? e.data.status.code : ''
                });
            }
        }

        yield put({ type: 'LOGIN_DONE' });

        yield take('PERFORM_LOGIN');
    }
}


// WEBPACK FOOTER //
// ./src/sagas/index.js